import { AttributeComponent } from "./interfaces/attribute.component";
import { AttributeDefinition } from "./models/attribute-definition";
import { Type } from "@angular/core";

export class DynamicAttribute{
    constructor(public component: Type<any>, public definition: AttributeDefinition){}
}